import Axios from "../../../api/axios/Axios";

export const getChannelProfile = (username) =>
  Axios.get(`/api/channels/${encodeURIComponent(username)}/profile`);
